import React, { useEffect, useState } from 'react';
import { Navigation } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-106">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-107">
          <img src="https://cdn.weweb.io/designs/95b2d8ad-3462-4b4f-8f64-0d1b08dcdb9e/sections/Lighthouse-Logomark__3_.svg?_wwcv=1748379697899" alt="Lighthouse AI" className="w-8 h-8" data-id="element-108" />
          <span className="font-display font-bold text-xl text-white tracking-tight" data-id="element-109">
            Lighthouse AI
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8" data-id="element-110">
          <button onClick={() => scrollToSection('features')} className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-111">
            Features
          </button>
          <button onClick={() => scrollToSection('how-it-works')} className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-112">
            How It Works
          </button>
          <button onClick={() => scrollToSection('faq')} className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-113">
            FAQ
          </button>
        </div>

        <div data-id="element-114">
          <button onClick={() => scrollToSection('join')} className="text-sm font-semibold bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-lg transition-colors border border-white/10" data-id="element-115">
            Join the Waitlist
          </button>
        </div>
      </div>
    </nav>;
}